import { IKImage } from "imagekitio-next";
import React from "react";

type SmallCardThumbnailMobileProps = {
  imageName: string;
  alt: string;
};

const urlEndpoint = process.env.NEXT_PUBLIC_BASE_IMAGE_KIT_URL;
const SmallCardThumbnailMobileUrlWidth = 400;
const SmallCardThumbnailMobileUrlHeight = 400;
const SmallCardThumbnailMobileUrlQuality = 70;

const SmallCardThumbnailMobile = (props: SmallCardThumbnailMobileProps) => {
  return (
    <IKImage
      urlEndpoint={urlEndpoint}
      path={props?.imageName || "default_image.jpg"}
      transformation={[{ crop: "maintain_ratio" }]}
      width={SmallCardThumbnailMobileUrlWidth}
      height={SmallCardThumbnailMobileUrlHeight}
      alt={props?.alt}
      lqip={{ active: true, quality: 20 }}
      loading="lazy"
      quality={SmallCardThumbnailMobileUrlQuality}
      className="rounded-[10px] w-full h-full object-cover"
      style={{ height: "100%", width: "100%" }}
    />
  );
};

export default SmallCardThumbnailMobile;
